var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('restore-widget',{attrs:{"title":_vm.$t('title'),"items":_vm.archivedBoards,"restore":_vm.doRestore,"delete":_vm.doDelete,"dismiss":_vm.dismiss,"data-loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }